import { createSelector } from 'reselect';

const selectAuth = (state) => state.auth;

export const selectAuthStatus = createSelector(selectAuth, (a) => a.status);
export const selectAuthToken  = createSelector(selectAuth, (a) => a.token);
export const selectAuthUser   = createSelector(selectAuth, (a) => a.user);
export const selectAuthOrg    = createSelector(selectAuth, (a) => a.org);
export const selectAuthError  = createSelector(selectAuth, (a) => a.error);
export const selectIsAuthenticated = createSelector(selectAuthStatus, (s) => s === 'authenticated');

export const selectSignupContext = (state) => state.auth.signupContext;
export const selectOtpStatus = (state) => state.auth.otpStatus;
export const selectOtpError = (state) => state.auth.otpError;
export const selectForgotStatus = (state) => state.auth.forgotStatus;
export const selectForgotError = (state) => state.auth.forgotError;
export const selectOnboardingPending = (state) => state.auth.onboardingPending;
export const selectSsoStatus = (state) => state.auth.ssoStatus;
export const selectSsoError = (state) => state.auth.ssoError;
export const selectLoginSource = (state) => state.auth.loginSource;
export const selectSsoContext = (state) => state.auth.ssoContext;
